export default __webpack_public_path__ + "static/media/apartment_2.e73d5a45.jpg";